var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineTranslate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.459 19.34a.763.763 0 0 1-.34-1.01l2.14-4.27a.76.76 0 0 1 .67-.41c.28 0 .54.16.67.42l2.14 4.27c.19.37.04.82-.34 1.01-.37.19-.82.04-1.01-.34l-1.46-2.93-1.46 2.93a.78.78 0 0 1-.68.41c-.11 0-.23-.03-.33-.08z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.16 18.66c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.52a.749.749 0 1 1 0 1.5h-3.52z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.09 16.92a5.83 5.83 0 1 1 11.66 0 5.83 5.83 0 0 1-11.66 0zm1.5.01c0 2.39 1.94 4.33 4.33 4.33 2.38 0 4.33-1.94 4.33-4.33s-1.94-4.33-4.33-4.33-4.33 1.94-4.33 4.33zM2.25 11.79c-.66-.64-1-1.61-1-2.86V5.01c0-2.43 1.34-3.77 3.77-3.77h3.92c1.25 0 2.21.33 2.86 1 .63.65.94 1.59.91 2.79v3.9c.03 1.22-.28 2.18-.93 2.83-.65.65-1.61.95-2.85.93h-3.9c-.07.01-.12.01-.17.01-1.11 0-1.99-.31-2.61-.91zm.5-6.77v3.92c0 .83.18 1.43.54 1.78.35.34.91.49 1.7.48h3.94c.84.02 1.42-.15 1.77-.5.35-.35.51-.94.49-1.75V5.01c.02-.8-.14-1.37-.48-1.72-.35-.36-.95-.54-1.78-.54H5.02c-1.61 0-2.27.66-2.27 2.27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.94 6.6c-.41 0-.75-.34-.75-.75s.34-.75.75-.75H9a.749.749 0 1 1 0 1.5H4.94z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.23 5.85v-.68c0-.41.34-.75.75-.75s.75.34.75.75v.68c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.19 9.01c0-.41.34-.75.75-.75 1.27 0 2.3-1.08 2.3-2.42 0-.41.34-.75.75-.75s.75.34.75.75c0 2.16-1.7 3.92-3.8 3.92-.41 0-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56 8.46a.75.75 0 0 1 1.2-.9c.34.46.79.71 1.25.71.41 0 .75.34.75.75s-.34.74-.75.74c-.93 0-1.82-.47-2.45-1.3zM1.25 15c0-.41.34-.75.75-.75s.75.34.75.75c0 2.96 2.06 5.44 4.83 6.09l-.27-.45a.751.751 0 1 1 1.29-.77l1.05 1.75c.14.23.14.52.01.75-.14.23-.39.38-.66.38-4.27 0-7.75-3.48-7.75-7.75zM21.25 9c0-2.96-2.06-5.44-4.83-6.09l.27.45a.751.751 0 1 1-1.29.77l-1.05-1.75a.745.745 0 0 1-.01-.75c.13-.24.38-.38.65-.38 4.27 0 7.75 3.48 7.75 7.75a.74.74 0 0 1-.74.75c-.41 0-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineTranslate);
export default __webpack_public_path__ + "static/media/vuesax-outline-translate.12c0c856bbab91e2690d3aa015d5f8f7.svg";
export { ForwardRef as ReactComponent };